import routeConfig from '../../constants/routeConfig'

const portalTab = {
  name: '/' + routeConfig.Portal.id,
  label: '首页概要',
  icon: 'iconfont icon-shouye',
  path: '/' + routeConfig.Portal.path,
  closable: false
}

const defaultTabs = [portalTab]

const layout = {
  state: {
    side: {
      navMenu: {
        isCollapsed: false,
        /* 小屏模式有效 */
        isShow: false
      }
    },
    main: {
      portal: portalTab,
      tab: {
        /* 选项卡数据 */
        options: defaultTabs,
        current: ''
      }
    },
    /* 非小屏模式有效 */
    fullScreen: false
  },
  mutations: {
    toggleCollapseSideNavMenu (state) {
      state.side.navMenu.isCollapsed = !state.side.navMenu.isCollapsed
    },
    expandSideNavMenu (state) {
      state.side.navMenu.isCollapsed = false
    },
    collapseSideNavMenu (state) {
      state.side.navMenu.isCollapsed = true
    },
    toggleShowSideNavMenu: function (state) {
      state.side.navMenu.isShow = !state.side.navMenu.isShow
    },
    showSideNavMenu: function (state) {
      state.side.navMenu.isShow = true
    },
    hideSideNavMenu: function (state) {
      state.side.navMenu.isShow = false
    },
    toggleFullScreen: function (state) {
      if (state.fullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        let docElement = document.documentElement
        if (docElement.requestFullscreen) {
          docElement.requestFullscreen()
        } else if (docElement.mozRequestFullScreen) {
          docElement.mozRequestFullScreen()
        } else if (docElement.webkitRequestFullScreen) {
          docElement.webkitRequestFullScreen()
        } else if (docElement.msRequestFullscreen) {
          docElement.msRequestFullscreen()
        }
      }
      state.fullScreen = !state.fullScreen
    },
    fullScreenChange: function (state) {
      if (!(document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement)) {
        state.fullScreen = false
      }
    },
    setMainTabs: function (state, tabs) {
      if (tabs && tabs.length >= defaultTabs.length) {
        if (defaultTabs.every((tab, index) => tabs[index].name === tab.name)) {
          state.main.tab.options = tabs
        }
      }
    },
    addMainTab: function (state, tab) {
      let tabOptions = state.main.tab.options
      let activeTab = tabOptions.find(option => option.name === tab.name)
      if (activeTab) {
        state.main.tab.current = activeTab.name
      } else {
        // 可关闭的标签
        tab.closable = true
        state.main.tab.options.push(tab)
        // 同时选中标签
        state.main.tab.current = tab.name
      }
    },
    removeMainTab: function (state, targetName) {
      let tabOptions = state.main.tab.options
      let activeName = state.main.tab.current
      let nextActiveName
      if (activeName === targetName) {
        let matches = tabOptions.some((option, index) => {
          if (option.name === activeName && option.closable) {
            let nextTab = tabOptions[index + 1] || tabOptions[index - 1]
            if (nextTab) {
              nextActiveName = nextTab.name
            }
            return true
          }
        })
        if (matches) {
          state.main.tab.current = nextActiveName
          state.main.tab.options = tabOptions.filter(option => option.name !== targetName || !option.closable)
        }
      } else {
        state.main.tab.options = tabOptions.filter(option => option.name !== targetName || !option.closable)
      }
    },
    removeMainActiveTab: function (state) {
      let tabOptions = state.main.tab.options
      let activeName = state.main.tab.current
      let nextActiveName
      let matches = tabOptions.some((option, index) => {
        if (option.name === activeName && option.closable) {
          let nextTab = tabOptions[index + 1] || tabOptions[index - 1]
          if (nextTab) {
            nextActiveName = nextTab.name
          }
          return true
        }
      })
      if (matches) {
        state.main.tab.current = nextActiveName
        state.main.tab.options = tabOptions.filter(option => option.name !== activeName || !option.closable)
      }
    },
    removeMainOtherTabs: function (state) {
      let tabOptions = state.main.tab.options
      let activeName = state.main.tab.current
      state.main.tab.options = tabOptions.filter(option => option.name === activeName || !option.closable)
    },
    removeMainLeftTabs: function (state) {
      let tabOptions = state.main.tab.options
      let activeName = state.main.tab.current
      let tabIndex = tabOptions.findIndex(option => option.name === activeName)
      if (tabIndex >= 0) {
        state.main.tab.options = tabOptions.filter((option, index) => index >= tabIndex || !option.closable)
      }
    },
    removeMainRightTabs: function (state) {
      let tabOptions = state.main.tab.options
      let activeName = state.main.tab.current
      let tabIndex = tabOptions.findIndex(option => option.name === activeName)
      if (tabIndex >= 0) {
        state.main.tab.options = tabOptions.filter((option, index) => index <= tabIndex || !option.closable)
      }
    },
    removeMainAllTabs: function (state) {
      let tabOptions = state.main.tab.options
      state.main.tab.options = tabOptions.filter(option => !option.closable)
      if (state.main.tab.options.length > 0) {
        /* 选中第一个 */
        state.main.tab.current = state.main.tab.options[0].name
      }
    },
    updatePortalTab: function (state, {label, icon}) {
      let portalTab = state.main.tab.options.find(option => option.name === routeConfig.Portal.id)
      if (portalTab) {
        let updated
        if (label && portalTab.label !== label) {
          portalTab.label = label
          updated = true
        }
        // if (icon && portalTab.icon !== icon) {
        //   portalTab.icon = icon
        //   updated = true
        // }
        if (updated) {
          portalTab.stamp = new Date().getTime()
        }
      }
    }
  },
  getters: {
    getMainActiveTab: function (state) {
      let tabOptions = state.main.tab.options
      return tabOptions.find(option => option.name === state.main.tab.current)
    }
  },
  actions: {
    setMainActiveTab: function (context, targetName) {
      let tabOptions = context.state.main.tab.options
      let hasTargetTab = tabOptions.some(option => option.name === targetName)
      if (hasTargetTab) {
        context.state.main.tab.current = targetName
        return true
      } else {
        context.commit('removeMainTab', targetName)
        return false
      }
    },
    addMainTabAction: function (context, tab) {
      let tabOptions = context.state.main.tab.options
      let activeTab = tabOptions.find(option => option.name === tab.name)
      if (activeTab) {
        context.state.main.tab.current = activeTab.name
        return false
      } else {
        tab.closable = true
        context.state.main.tab.options.push(tab)
        context.state.main.tab.current = tab.name
        return true
      }
    }
  }
}

export default layout
